<template>
  <v-container fluid class="pa-0 pa-sm-6 profile-page-bg">
    <v-layout align-start justify-center>
      <v-flex xs12 lg10 xl8>
        <!-- MODERN HEADER WITH PREMIUM GLASSMORPHISM -->
        <div class="glass-header mb-8 pa-6 pa-md-10 rounded-xl elevation-10 animate-fade-in-down">
          <v-row align="center">
            <v-col cols="12" md="8">
              <div class="d-flex flex-column flex-sm-row align-center text-center text-sm-left">
                <v-hover v-slot="{ hover }">
                  <v-avatar size="140" class="elevation-12 avatar-border mb-4 mb-sm-0 mr-sm-8 clickable"
                    @click="dialogImage = true">
                    <v-img :src="profileImage || require('@/assets/user.png')">
                      <v-fade-transition>
                        <v-overlay v-if="hover" absolute color="black" opacity="0.4">
                          <v-icon color="white" size="32">photo_camera</v-icon>
                        </v-overlay>
                      </v-fade-transition>
                    </v-img>
                  </v-avatar>
                </v-hover>
                <div class="white--text">
                  <h1 class="text-h3 font-weight-black mb-2 tracked-tight">{{ data_users.fullname }}</h1>
                  <div class="d-flex flex-wrap align-center justify-center justify-sm-start mt-2">
                    <v-chip color="rgba(255,255,255,0.15)" dark outlined
                      class="font-weight-bold mr-3 mb-2 backdrop-blur">
                      <v-icon x-small left color="white">alternate_email</v-icon>
                      {{ data_users.username }}
                    </v-chip>
                    <v-chip color="rgba(255,255,255,0.15)" dark outlined
                      class="font-weight-bold mr-3 mb-2 backdrop-blur">
                      <v-icon x-small left color="white">verified_user</v-icon>
                      {{ data_users.userr_rol || 'Usuario Estándar' }}
                    </v-chip>
                    <v-chip v-if="data_users.status" color="success" dark small class="mb-2 font-weight-bold">
                      Activo
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="text-center text-md-right">

            </v-col>
          </v-row>
        </div>

        <v-row class="animate-fade-in-up" style="animation-delay: 0.2s">
          <!-- SECTION: PERSONAL & CONTACT INFO -->
          <v-col cols="12" md="4">
            <v-card class="modern-card h-100 overflow-hidden" elevation="4">
              <div class="card-header-accent primary"></div>
              <v-card-title class="pa-6">
                <v-icon color="primary" class="mr-3">contact_mail</v-icon>
                <span class="text-h6 font-weight-bold">Contacto</span>
              </v-card-title>
              <v-divider class="mx-6"></v-divider>
              <v-card-text class="pa-6">
                <div class="info-item mb-6">
                  <div class="caption grey--text font-weight-bold text-uppercase mb-1">Correo Electrónico</div>
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2">email</v-icon>
                    <span class="text-body-1">{{ data_users.use_email || 'No registrado' }}</span>
                  </div>
                </div>

                <div class="info-item mb-6">
                  <div class="caption grey--text font-weight-bold text-uppercase mb-1">Teléfono</div>
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2">phone</v-icon>
                    <span class="text-body-1">{{ data_users.use_telephone || 'N/A' }}</span>
                    <v-chip v-if="data_users.use_telephone_extension" x-small color="grey lighten-3" class="ml-2">
                      Ext: {{ data_users.use_telephone_extension }}
                    </v-chip>
                  </div>
                </div>

                <div class="info-item">
                  <div class="caption grey--text font-weight-bold text-uppercase mb-1">Móvil</div>
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-2">smartphone</v-icon>
                    <span class="text-body-1">{{ data_users.use_movil || 'No registrado' }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- SECTION: PROFESSIONAL INFO -->
          <v-col cols="12" md="4">
            <v-card class="modern-card h-100 overflow-hidden" elevation="4">
              <div class="card-header-accent secondary"></div>
              <v-card-title class="pa-6">
                <v-icon color="secondary" class="mr-3">business_center</v-icon>
                <span class="text-h6 font-weight-bold">Información Laboral</span>
              </v-card-title>
              <v-divider class="mx-6"></v-divider>
              <v-card-text class="pa-6">
                <div v-if="data_users.employee_data && data_users.employee_data.length > 0">
                  <div class="info-item mb-6">
                    <div class="caption grey--text font-weight-bold text-uppercase mb-1">Cargo / Puesto</div>
                    <div class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-2">work</v-icon>
                      <span class="text-body-1 font-weight-medium text--primary">{{
                        data_users.employee_data[0].jobtitle_name }}</span>
                    </div>
                  </div>

                  <div class="info-item mb-6">
                    <div class="caption grey--text font-weight-bold text-uppercase mb-1">Ubicación / Dependencia</div>
                    <div class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-2">location_on</v-icon>
                      <span class="text-body-2">{{ data_users.employee_data[0].location_description_long }}</span>
                    </div>
                  </div>

                  <div class="info-item">
                    <div class="caption grey--text font-weight-bold text-uppercase mb-1">Código de Empleado</div>
                    <div class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-2">tag</v-icon>
                      <v-chip small color="secondary lighten-5" class="secondary--text font-weight-black">
                        {{ data_users.employee_data[0].employee_code }}
                      </v-chip>
                    </div>
                  </div>
                </div>
                <div v-else class="text-center py-10 grey--text">
                  <v-icon size="48" color="grey lighten-3" class="mb-2">history_edu</v-icon>
                  <div>No hay datos laborales vinculados</div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- SECTION: ACCESS & PERMISSIONS -->
          <v-col cols="12" md="4">
            <v-card class="modern-card h-100 overflow-hidden" elevation="4">
              <div class="card-header-accent warning"></div>
              <v-card-title class="pa-6">
                <v-icon color="warning" class="mr-3">key</v-icon>
                <span class="text-h6 font-weight-bold">Acceso y Permisos</span>
              </v-card-title>
              <v-divider class="mx-6"></v-divider>
              <v-card-text class="pa-6">
                <v-row dense>
                  <v-col cols="6">
                    <div class="access-stat pa-4 rounded-lg grey lighten-5 text-center mb-4">
                      <div class="text-h5 font-weight-black warning--text">{{ data_users.profiless_data ?
                        data_users.profiless_data.length : 0 }}</div>
                      <div class="caption grey--text text-uppercase">Módulos</div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="access-stat pa-4 rounded-lg grey lighten-5 text-center mb-4">
                      <div class="text-h5 font-weight-black info--text">{{ data_users.feature_access ?
                        data_users.feature_access.length : 0 }}</div>
                      <div class="caption grey--text text-uppercase">Funciones</div>
                    </div>
                  </v-col>
                </v-row>

                <div class="caption grey--text font-weight-bold text-uppercase mb-2">Módulos Asignados</div>
                <div class="d-flex flex-wrap">
                  <v-tooltip v-for="mod in data_users.profiless_data" :key="mod.module_id" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-bind="attrs" v-on="on" x-small
                        :color="mod.is_custom ? 'orange lighten-4' : 'blue lighten-4'"
                        :text-color="mod.is_custom ? 'orange darken-4' : 'blue darken-4'"
                        class="mr-1 mb-1 font-weight-bold">
                        {{ mod.module_name || mod.module_code }}
                      </v-chip>
                    </template>
                    <span>Código: {{ mod.module_code }}</span>
                  </v-tooltip>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- SECTION: SECURITY & PREFERENCES -->
          <v-col cols="12">
            <v-card class="modern-card mt-4 overflow-hidden" elevation="4">
              <v-tabs v-model="activeTab" background-color="transparent" color="primary" grow>
                <v-tab class="font-weight-bold"><v-icon left>security</v-icon>Seguridad</v-tab>
                <v-tab class="font-weight-bold"><v-icon left>palette</v-icon>Personalización</v-tab>
                <v-tab v-if="$store.state.auth.globalFeatures.includes('SHOP-143')" class="font-weight-bold"><v-icon left>notifications</v-icon>Notificaciones</v-tab>
              </v-tabs>
              <v-divider></v-divider>

              <v-tabs-items v-model="activeTab" class="transparent">
                <!-- SEGURIDAD TAB -->
                <v-tab-item>
                  <v-card-text class="pa-8">
                    <v-row align="center">
                      <v-col cols="12" md="5" class="text-center py-6">
                        <v-avatar size="120" color="primary lighten-5" class="mb-4">
                          <v-icon size="64" color="primary">lock</v-icon>
                        </v-avatar>
                        <h3 class="text-h6 font-weight-bold grey--text text--darken-3">Protección de Cuenta</h3>
                        <p class="body-2 grey--text">Cambie su contraseña periódicamente para mantener su cuenta segura.
                        </p>
                        <v-btn v-if="!updatePassword" color="primary" rounded depressed large
                          @click="updatePassword = true" class="px-8 mt-4">
                          Actualizar Contraseña
                        </v-btn>
                      </v-col>

                      <v-col cols="12" md="7">
                        <v-fade-transition hide-on-leave>
                          <div v-if="updatePassword" class="pa-4 glass-card">
                            <v-text-field label="Contraseña actual" outlined dense rounded filled
                              :type="showPassword.old ? 'text' : 'password'"
                              :append-icon="showPassword.old ? 'visibility' : 'visibility_off'"
                              @click:append="showPassword.old = !showPassword.old" v-model="data_users.oldPassword"
                              prepend-inner-icon="lock_open" class="mb-4"></v-text-field>

                            <v-text-field label="Nueva Contraseña" outlined dense rounded filled
                              :type="showPassword.new ? 'text' : 'password'"
                              :append-icon="showPassword.new ? 'visibility' : 'visibility_off'"
                              @click:append="showPassword.new = !showPassword.new" v-model="data_users.newPassword"
                              prepend-inner-icon="key" class="mb-4"></v-text-field>

                            <v-text-field label="Verificar Nueva Contraseña" outlined dense rounded filled
                              v-model="data_users.checkPassword" :type="showPassword.check ? 'text' : 'password'"
                              :append-icon="showPassword.check ? 'visibility' : 'visibility_off'"
                              @click:append="showPassword.check = !showPassword.check"
                              prepend-inner-icon="verified_user" class="mb-6"></v-text-field>

                            <div class="d-flex">
                              <v-btn text rounded color="grey darken-1" @click="cancelPasswordChange"
                                class="mr-2">Cancelar</v-btn>
                              <v-btn color="success" rounded depressed block @click="changePassword">
                                <v-icon left>done</v-icon>Confirmar Cambio
                              </v-btn>
                            </div>
                          </div>
                          <div v-else class="d-none d-md-flex align-center justify-center fill-height py-12">
                            <v-alert type="info" text class="rounded-xl w-100" icon="shield">
                              Su nombre de usuario es <strong>{{ data_users.use_username }}</strong>.
                              Recuerde no compartir sus credenciales con terceros.
                            </v-alert>
                          </div>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-tab-item>

                <!-- PERSONALIZACION TAB -->
                <v-tab-item>
                  <v-card-text class="pa-8 text-center">
                    <div class="text-subtitle-1 grey--text text--darken-2 mb-8 font-weight-medium">
                      Adapte la interfaz a su estilo visual preferido
                    </div>

                    <div class="d-flex justify-center flex-wrap mb-10">
                      <v-hover v-for="(color, name) in colorPalette" :key="name" v-slot="{ hover }">
                        <div class="text-center ma-4">
                          <v-card @click="changeColor(name)"
                            :class="['color-card rounded-circle', isSelected(name) ? 'selected' : '']" :color="color"
                            :height="hover ? 70 : 60" :width="hover ? 70 : 60" elevation="4">
                            <v-icon v-if="isSelected(name)" color="white" size="30">check</v-icon>
                          </v-card>
                          <div class="caption mt-2 font-weight-bold text-capitalize grey--text text--darken-1">{{ name
                          }}</div>
                        </div>
                      </v-hover>
                    </div>

                    <v-btn color="primary" depressed rounded x-large class="px-12" @click="saveChanges">
                      <v-icon left>save</v-icon>
                      Guardar Preferencias
                    </v-btn>
                  </v-card-text>
                </v-tab-item>

                <!-- NOTIFICACIONES TAB -->
                <v-tab-item v-if="$store.state.auth.globalFeatures.includes('SHOP-143')">
                  <v-card-text class="pa-8">
                    <v-row align="center" justify="center">
                      <v-col cols="12" md="6" class="text-center py-6">
                        <v-avatar size="120" color="blue lighten-5" class="mb-4">
                          <v-icon size="64" color="blue darken-1">notifications</v-icon>
                        </v-avatar>
                        <h3 class="text-h6 font-weight-bold grey--text text--darken-3">Alertas automáticas</h3>
                        <p class="body-2 grey--text">Controla si deseas recibir notificaciones por correo cuando una orden requiera tu aprobación.</p>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card outlined rounded="xl" class="pa-6">
                          <v-switch
                            v-model="receiveAlerts"
                            :label="receiveAlerts ? 'Notificaciones activadas' : 'Notificaciones desactivadas'"
                            :color="receiveAlerts ? 'success' : 'grey'"
                            hide-details
                            :loading="loadingAlerts"
                            @change="saveNotificationSettings"
                          ></v-switch>
                          <p class="caption grey--text mt-4 mb-0">
                            Al desactivar esta opción, no recibirás correos automáticos cuando se requiera tu aprobación en una orden de compra.
                          </p>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>

        <!-- IMAGE DIALOG -->
        <v-dialog v-model="dialogImage" max-width="500px" transition="scale-transition">
          <v-card class="modern-card overflow-hidden">
            <v-card-title class="pa-6 border-bottom primary white--text">
              <span class="text-h6 font-weight-bold">Personalizar Avatar</span>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dialogImage = false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-8 text-center bg-dots">
              <v-avatar size="180" class="mb-6 elevation-8 avatar-border">
                <v-img v-if="image_preview" :src="image_preview"></v-img>
                <v-img v-else-if="profileImage" :src="profileImage"></v-img>
                <v-icon v-else size="100" color="grey lighten-2">person</v-icon>
              </v-avatar>

              <v-file-input v-model="foto" id="fileInput" accept="image/*" outlined rounded filled
                label="Seleccionar imagen de perfil" prepend-icon="" prepend-inner-icon="add_photo_alternate"
                @change="onFileChange" class="mt-4"></v-file-input>

              <p class="caption grey--text mt-2 mx-6">Formatos sugeridos: JPG, PNG. Tamaño máximo recomendado: 2MB.</p>
            </v-card-text>
            <v-card-actions class="pa-6 grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn text color="grey darken-1" @click="dialogImage = false" class="px-6" rounded>Cancelar</v-btn>
              <v-btn color="primary" depressed rounded class="px-8" @click="upImage">
                <v-icon left>cloud_upload</v-icon>
                Subir Imagen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  data: () => ({
    activeTab: 0,
    updatePassword: false,
    dialogImage: false,
    foto: null,
    image_preview: null,
    data_users: {
      employee_data: [],
      profiless_data: [],
      feature_access: []
    },
    showPassword: {
      old: false,
      new: false,
      check: false,
    },
    colorPalette: {
      vuedy: "#536DFE",
      royal: "#3F51B5",
      ocean: "#1976D2",
      sunset: "#FF9800",
      flame: "#FF3D00",
      forest: "#009688",
      rose: "#E91E63",
      emerald: "#10B981",
      violet: "#8B5CF6",
      amber: "#F59E0B",
      onyx: "#424242",
    },
    activeColor: null,
    receiveAlerts: true,
    loadingAlerts: false,
  }),

  computed: {
    profileImage() {
      return this.data_users?.image_storage ? this.get_storage(this.data_users.image_storage) : null;
    }
  },

  created() {
    this.initialize();
    this.activeColor = window.localStorage.getItem("active_color_key") || 'vuedy';
  },

  methods: {
    async initialize() {
      try {
        let id = this.$store.state.auth.user.user.user_id;
        const resultData = await this.api_Get("auth/user_details/" + id);
        let data = await resultData.json();
        // Preservamos la estructura si data[0] existe
        if (data && data[0]) {
          this.data_users = data[0];
        }
      } catch (error) {
        this.$toast.error("Error al cargar perfil");
      }

      if (this.$store.state.auth.globalFeatures.includes('SHOP-143')) {
        try {
          const userId = this.$store.state.auth.user.user.user_id;
          const res = await this.api_Get(`auth/notification_settings/${userId}`);
          if (res.status === 200) {
            const d = await res.json();
            this.receiveAlerts = d.receive_automatic_alerts;
          }
        } catch (_) { /* no bloquea la carga del perfil */ }
      }
    },

    formatDate(date) {
      if (!date) return 'Nunca';
      return moment(date).format('DD/MM/YYYY HH:mm');
    },

    isSelected(name) {
      return this.activeColor === name;
    },

    changeColor(colorKey) {
      const color = this.colorPalette[colorKey];
      this.activeColor = colorKey;
      this.$vuetify.theme.themes.light.primary = color;
      window.localStorage.setItem("color_preference", color);
      window.localStorage.setItem("active_color_key", colorKey);
      this.$toast.info(`Tema ${colorKey} aplicado temporalmente`, { timeout: 1000 });
    },

    async saveChanges() {
      try {
        const result = await this.api_Put("auth/perfil", {
          id: this.$store.state.auth.user.user.user_id,
          color_preference: window.localStorage.getItem("color_preference"),
        });

        if (result.status == 200) {
          this.$toast.success("Preferencias de estilo sincronizadas correctamente");
        }
      } catch (error) {
        this.$toast.error("Error al guardar preferencias");
      }
    },

    async changePassword() {
      if (!this.data_users.oldPassword || !this.data_users.newPassword) {
        return this.$toast.warning("Complete todos los campos de contraseña");
      }
      if (this.data_users.newPassword !== this.data_users.checkPassword) {
        return this.$toast.warning("Las nuevas contraseñas no coinciden");
      }

      try {
        const result = await this.api_Put("auth/updatePassword", {
          id: this.$store.state.auth.user.user.user_id,
          password: this.data_users.oldPassword,
          newpassword: this.data_users.newPassword,
        });

        if (result.status == 200) {
          this.$toast.success("Contraseña actualizada con éxito");
          this.cancelPasswordChange();
        } else if (result.status == 401) {
          this.$toast.error("La contraseña actual es incorrecta");
        }
      } catch (error) {
        this.$toast.error("Error al cambiar contraseña");
      }
    },

    cancelPasswordChange() {
      this.data_users.oldPassword = "";
      this.data_users.newPassword = "";
      this.data_users.checkPassword = "";
      this.updatePassword = false;
    },

    async saveNotificationSettings() {
      this.loadingAlerts = true;
      try {
        const res = await this.api_Put("auth/notification_settings", {
          user_id: this.$store.state.auth.user.user.user_id,
          receive_automatic_alerts: this.receiveAlerts,
        });
        if (res.status === 200) {
          this.$toast.success(
            this.receiveAlerts ? "Notificaciones activadas" : "Notificaciones desactivadas"
          );
        } else {
          this.$toast.error("Error al guardar la preferencia");
        }
      } catch (e) {
        this.$toast.error("Error al guardar la preferencia");
      } finally {
        this.loadingAlerts = false;
      }
    },

    onFileChange(file) {
      if (file) {
        this.image_preview = URL.createObjectURL(file);
      } else {
        this.image_preview = null;
      }
    },

    async upImage() {
      if (!this.foto) return this.$toast.warning("Seleccione una imagen");

      try {
        const result = await this.upload_to_spaces(this.foto, "profile_images");
        const responseRequest = await this.api_Put("auth/userImage", {
          user_id: this.$store.state.auth.user.user.user_id,
          image_storage: { url: result.url, key: result.key, name: this.foto.name },
        });

        if (responseRequest.ok) {
          this.$toast.success("Imagen actualizada con éxito");
          this.initialize();
          this.dialogImage = false;
          this.foto = null;
          this.image_preview = null;
        }
      } catch (e) {
        this.$toast.error("Error al subir imagen");
      }
    },
  },
};
</script>

<style scoped>
.profile-page-bg {
  background-color: #f8faff;
  min-height: 100vh;
}

.glass-header {
  background: linear-gradient(135deg, var(--v-primary-base) 0%, #1a2a6c 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.glass-header::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.avatar-border {
  border: 6px solid rgba(255, 255, 255, 0.2);
  background: white;
}

.modern-card {
  border-radius: 24px !important;
  border: 1px solid rgba(226, 232, 240, 0.8) !important;
  background: white !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.modern-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08) !important;
}

.card-header-accent {
  height: 6px;
  width: 100%;
}

.backdrop-blur {
  backdrop-filter: blur(8px);
}

.stats-badge {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 180px;
}

.info-item .caption {
  letter-spacing: 0.08em;
}

.access-stat {
  border: 1px dashed #e2e8f0;
}

.color-card {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid white !important;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.color-card.selected {
  transform: scale(1.2);
  border-color: #f1f5f9 !important;
  box-shadow: 0 0 0 4px var(--v-primary-base);
}

.glass-card {
  background: rgba(248, 250, 252, 0.8);
  border-radius: 16px;
  border: 1px solid #e2e8f0;
}

.bg-dots {
  background-image: radial-gradient(#e2e8f0 1px, transparent 1px);
  background-size: 20px 20px;
}

.h-100 {
  height: 100%;
}

.tracked-tight {
  letter-spacing: -0.025em;
}

.animate-fade-in-down {
  animation: fadeInDown 0.6s ease-out;
}

.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out both;
}

.clickable {
  cursor: pointer;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom Scrollbar for better look */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
